import { AttentionStates } from '../../core/enums/attentionsStates';
import { Attention } from './attention';

export function isUnfinishedCaseAttention(attention: Attention): boolean {
    return !attention?.isSupply
        && attention?.practice?.name !== 'Entrega insumos'
        && [AttentionStates.AGENDADA, AttentionStates.EN_CURSO].includes(attention?.state?.id);
}
